import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import { Divider, Tooltip, Typography } from "@mui/material";

import { CardCore } from "../CardCore/CardCore";
import { LinkCore } from "../LinkCore/LinkCore";

interface ICardHelp {
  id: string;
  title: string;
  description: string;

  page: {
    title: string;
    url: string;
  };
}

export const CardHelp = ({ description, id, title, page }: ICardHelp) => {
  return (
    <CardCore
      key={id}
      sxStyle={{
        margin: 0,
        height: "100%",
        display: "flex",

        overflow: "hidden",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Typography
        sx={{
          width: "calc(100% - 50px)",
          marginBottom: "4px",
          fontWeight: "500",
        }}
      >
        {title}
      </Typography>

      <Divider sx={{ margin: "12px 0" }} />

      <Typography
        sx={{ flex: 1, fontSize: { xs: "12px", sm: "14px" } }}
        color="text.secondary"
      >
        {description}
      </Typography>

      <Divider sx={{ margin: "12px 0" }} />

      <LinkCore to={page.url}>
        <Tooltip arrow title="Ir para a página">
          <Typography
            sx={{
              fontWeight: "600",
              color: (theme) => theme.palette.primary.main,
              display: "flex",
              letterSpacing: "0.04rem",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {page.title}
            <DoubleArrowIcon sx={{ fontSize: "16px" }} />
          </Typography>
        </Tooltip>
      </LinkCore>
    </CardCore>
  );
};
